import React from 'react';

export type Quality = 'low' | 'medium' | 'high';

interface QualitySliderProps {
    value: Quality;
    onChange: (q: Quality) => void;
    className?: string;
}

const LABELS: Record<Quality, string> = {
    low: 'Low (faster)',
    medium: 'Medium',
    high: 'High (slower)',
};

/**
 * A small, modular three-state quality slider.
 * - value: current quality
 * - onChange: called with new quality
 * This component is intentionally self-contained and can be reused elsewhere.
 */
export default function QualitySlider({ value, onChange, className }: QualitySliderProps) {
    const options: Quality[] = ['low', 'medium', 'high'];

    return (
        <div className={`${className || ''} quality-slider`}>
            <div className="quality-slider__row" role="radiogroup" aria-label="AI quality">
                {options.map((opt) => {
                    const selected = opt === value;
                    return (
                        <button
                            key={opt}
                            role="radio"
                            aria-checked={selected}
                            onClick={() => onChange(opt)}
                            className={`btn quality-slider__btn ${selected ? 'btn-primary' : 'btn-secondary'}`}
                        >
                            {LABELS[opt]}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
